/**
 * Stana tile video — play when in view, pause when out of view.
 * Keeps silent autoplay loops lightweight without touching theme bundles.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (!(video instanceof HTMLVideoElement)) return;

        if (entry.isIntersecting) {
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(() => {});
          }
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.25 }
  );

  function observeVideos(root) {
    root.querySelectorAll('[data-stana-tile-video]').forEach((wrap) => {
      const video = wrap.querySelector('video');
      if (video) observer.observe(video);
    });
  }

  document.addEventListener('DOMContentLoaded', () => observeVideos(document));

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) observeVideos(event.target);
  });
})();
